import React from "react";

//!code is from ai
const images = [
  "/vector.png",
  "/logoo.svg",
  "/vector.png",
  "/logoo.svg",
   "/vector.png",
  "/logoo.svg",
  "/vector.png",
  "/logoo.svg",
];

const Carousel = () => {
  return (
    <div className="carousel-container">
      <div className="carousel-track">
        {images.map((img, index) => (
          <div className="carousel-item" key={index}>
            <img src={img} alt={`slide-${index}`} />
          </div>
        ))}
        
        {images.map((img, index) => (
          <div className="carousel-item" key={index + images.length}>
            <img src={img} alt={`slide-dup-${index}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Carousel;